import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Checkbox, FormControl, FormControlLabel, Grid } from '@material-ui/core';
import { btMediumGrayColor } from '../../../assets/jss/nextjs-material-kit-pro';
import { stripLeadingNumber, isAdminOrFHT, isStudent, isAlumni, isFHT } from '../../../util/miscUtil';

const styles = makeStyles((theme) => ({
  checklistRow: {
    margin: '10px 0',
    padding: '15px 0',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  checklistColumn: {
    alignItems: 'center',
  },
  checkboxCell: {
    display: 'flex',
    alignItems: 'flex-start',
    marginTop: 0,
  },
  pointsLabel: {
    fontSize: '1.00rem',
    lineHeight: 1.5,
    fontWeight: 400,
    color: btMediumGrayColor,
  },
  dueLabel: {
    fontSize: '1.00rem',
    lineHeight: 1.5,
    fontWeight: 400,
    color: btMediumGrayColor,
  },
  datePickerRowSpacer: {
    height: 50,
    paddingTop: 8,
    marginBottom: 10,
  },
  datepicker: {
    width: '160px',
    '& .MuiFilledInput-root': {
      background: 'rgb(255, 255, 255)',
    },
  },
  printedContent: {
    '@media print': {
      marginBottom: 10,
    },
    '@media screen': {
      display: 'none',
    },
  },
  unprintedContent: {
    '@media print': {
      display: 'none',
    },
    '@media screen': {},
  },
  alignPrintedContent: {
    verticalAlign: 'top',
    fontSize: '1.00rem',
    lineHeight: 1.5,
    fontWeight: 400,

    marginTop: 5,
  },
  underline: {
    margin: '5px 0',
    borderBottom: '1px solid #000',
  },
  checkOutline: {
    border: '1px solid #000',
    borderRadius: 6,
    maxWidth: '35px',
    alignContent: 'center',
    minWidth: '35px',
  },
  subtleBold: {
    fontWeight: 500,
    color: btMediumGrayColor,
  },
}));

function renderChecklistItem(item, form, setForm, classes, isFieldDisabled, isConfirmDisabled, includesStudent, act, startIndex) {
  // const includesStudent = true; //isStudent(auth.roles);
  return (
    <Grid
      container
      direction="row"
      alignItems="center"
      style={{ marginBottom: 10 }}
      className={classes.unprintedContent + ' ' + classes.checkListRow}
      key={item.key}
    >
      <Grid item xs={12} sm={12} md={8} lg={8} className={classes.checklistColumn}>
        <FormControl fullWidth>
          <FormControlLabel
            control={<Checkbox color="default" style={{ alignSelf: 'flex-start' }} />}
            label={`${startIndex}. ${stripLeadingNumber(item.label)}`}
            disabled={isFieldDisabled(form[item.confirmKey])}
            checked={form[item.key]}
            onChange={() => setForm({ ...form, [item.key]: !form[item.key] })}
          />
          {item.extra && item.extra(act, includesStudent, classes)}
        </FormControl>
      </Grid>
      <Grid item xs={3} sm={3} md={1} lg={1} align="right" style={{ paddingRight: '3%' }} className={classes.checklistColumn}>
        <div className={classes.pointsLabel}>{item.points}</div>
      </Grid>
      <Grid item xs={6} sm={6} md={2} lg={2} align="left" className={classes.checklistColumn}>
        <div className={classes.dueLabel}>{item.due}</div>
      </Grid>
      <Grid item xs={3} sm={3} md={1} lg={1} align="right" style={{ paddingRight: '2.5%' }} className={classes.checklistColumn}>
        <Checkbox
          color="default"
          disabled={isConfirmDisabled(form[item.key])}
          checked={form[item.confirmKey]}
          onChange={() => setForm({ ...form, [item.confirmKey]: !form[item.confirmKey] })}
        ></Checkbox>
      </Grid>
    </Grid>
  );
}

export default function PostSecondaryEducationItems(props) {
  const { form, setForm, auth, act, startIndex, points, formClasses, items } = props;

  const classes = styles();

  const hasItems = items && items.length > 0;

  const isFieldDisabled = (val) => {
    return !!isAdminOrFHT(auth.roles);
  };

  const isConfirmDisabled = (val) => {
    return !!(isStudent(auth.roles) || isAlumni(auth.roles) || isFHT(auth.roles));
  };

  let number = startIndex;
  const includesStudent = isStudent(auth.roles);
  return (
    <React.Fragment>
      {hasItems && (
        <Grid container direction="row" className={formClasses?.sectionSpacer}>
          <Grid item xs={7} align="left">
            <section align="left" className={formClasses?.sectionTitle}>
              Post-Secondary Education Option
            </section>
          </Grid>
          <Grid item xs={2}>
            <section align="right" className={formClasses?.sectionTitle}>
              <div style={{ fontSize: '1.15rem', fontWeight: 600, paddingRight: '30px' }}>{points}</div>
            </section>
          </Grid>
          <Grid item xs={3}>
            <section align="center" className={formClasses?.sectionTitle}>
              <br />
            </section>
          </Grid>
        </Grid>
      )}
      {hasItems &&
        items.map((item) => {
          const rendered = renderChecklistItem(item, form, setForm, classes, isFieldDisabled, isConfirmDisabled, includesStudent, act, number);
          number++;
          return rendered;
        })}
    </React.Fragment>
  );
}

PostSecondaryEducationItems.propTypes = {
  form: PropTypes.object,
  setForm: PropTypes.func,
  auth: PropTypes.object,
  act: PropTypes.number,
  alumni: PropTypes.bool.isRequired,
  startIndex: PropTypes.number,
  points: PropTypes.number,
  formClasses: PropTypes.object,
  items: PropTypes.array,
};
